import React from "react";
import { Row } from "antd";

const Orders = () => {
    return (
        <Row justify="center">
            <h1>Bro whats up this is the Orders component</h1>
        </Row>
    )
}

export default Orders